module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-header.eb022b66.png";